<template>
  <div class="common-arg content-container">
    <el-collapse>
      <el-collapse-item title="" name="1">
        <template slot="title">
          <h2>{{ $t("message.PublicParameter") }}</h2>
        </template>
        <mavon-editor
            v-model="content"
            ref="md"
            @change="change"
            style="style"
            :defaultOpen="defaultOpen"
            :subfield="subfield"
            :toolbarsFlag="toolbarsFlag"
            :editable="editable"
        />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  props: ['contentEditable'],
  data () {
    return {
      content: `
${this.$t('message.PublicParameter')}:
|${this.$t('message.Field')}|${this.$t('message.Description')}|${this.$t('message.Memo')}|${this.$t('message.Value')}|
|-|-|-|-|
|customerId|${this.$t('message.User')}id|${this.$t('message.wmsAccount')}|==${this.$t('message.ProvidedByVwms')}==
|appkey|appkey|${this.$t('message.forGenSign')}|==${this.$t('message.ProvidedByVwms')}==
|secretkey|secretkey|${this.$t('message.forGenSign')}|==${this.$t('message.ProvidedByVwms')}==
|warehouseCode|${this.$t('message.WarehouseCode')}|${this.$t('message.WarehouseCode')}|==${this.$t('message.ProvidedByVwms')}==
|NotificaitonURL|${this.$t('message.ResponseUrl')}|${this.$t('message.UrlForErp')}|==${this.$t('message.ProvidedByErp')}==

      `,
      editable: true,
      subfield: true,
      toolbarsFlag: true,
      defaultOpen: null,
      style: ''
    }
  },
  methods: {
    change () {
      if (this.contentEditable) {
        this.subfield = true
        this.toolbarsFlag = true
        this.editable = true
        this.defaultOpen = null
        this.style = ''
      } else {
        this.subfield = false
        this.toolbarsFlag = false
        this.editable = false
        this.defaultOpen = 'preview'
        this.style = 'height: 100%'
      }
    }
  },
  watch: {
    contentEditable: {
      handler (val, oldval) {
        this.change()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/openapi/CommonArg.vue